import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { getUrlEnvironment } from '../shared/environment';

export interface ServicesDetail {
    No_Os: String;
    Consecutivo_SS: String;
    Nom_Material: String;
    Cantidad_en_Kg: String;
    Nom_Embalaje: String;
    Cantidad_Embalaje: String;
    status: string;
    Peso_Recogidos_Kg: string;
    Peso_Aproximado_Kg: string;
    Compromiso_Servicio: string;
}

export interface Generic {
    id: number;
    label: string;
    data: string;
}

export interface Result {
    status: string;
    id: string;
    result: string;
}

export interface Status {
    id: string;
    status: string;
    motive: String;
}

export interface Services {
    Services: Array<ServicesDetail>;
}

@Injectable()
export class ServicesService {
    private datos;

    constructor(private http: HttpClient, private router: Router, private auth: AuthenticationService) { }

    private listServices(unidades, sucursales): Observable<any> {
        let base;
        const url = this.getQueryListServices();
        base = this.http.get(url);
        const request = base.pipe(
            map((data: any) => {
                return this.processListServices(data, unidades, sucursales);
            })
        );
        return request;
    }

    private processListServices(data: any, unidades: any, sucursales: any) {
        var servicios = [];
        for (let i = 0; i < data.length; i++) {
            var resFecha = '';
            if (data[i][11]) {
                let from: Date = new Date(data[i][11]);
                var startDate = from.getFullYear() + " - " + from.getMonth() + " - " + from.getDate() + " - " + from.getHours() + ": " + from.getMinutes() + ":" + from.getSeconds();
                const mon = (from.getMonth() < 9) ? '0' + (from.getMonth() + 1) : (from.getMonth() + 1);
                const day = (from.getDate() < 9) ? '0' + from.getDate() : from.getDate();
                resFecha = from.getFullYear() + '/' + mon + '/' + day;
            }
            else {
                resFecha = 'Pendiente de asignación';
            }
            let un = data[i][12];
            let un2 = data[i][13];
            let uniName = '';
            const uni = unidades.filter(tipo => ((tipo.id == un) || (tipo.id == un2)));
            if (uni.length > 0) {
                uniName = uni[0].label;
            }
            let sucName = data[i][14];
            const suc = data[i][14];
            const res = sucursales.filter(tipo => tipo.id == suc);
            if (res.length > 0) {
                sucName = res[0].label;
            }
            let resu = {
                Sucursal: sucName,
                OS: data[i][0],
                Solicitud: data[i][1],
                Estado: data[i][6],
                Material: data[i][2],
                Reportada: data[i][3],
                Recogida: data[i][9],
                UN: uniName,
                Embalaje: data[i][4],
                CtnEmbalaje: data[i][5],
                servicio: resFecha,
                Valor: data[i][8],
                id: data[i][7],
                manifiestoT: data[i][15]
            };
            servicios.push(resu);
        }
        return servicios;
    }

    private getQueryListServices() {
        var query = 'select No_Os,Consecutivo_SS,Nom_Material,Cantidad_en_Kg,Nom_Embalaje,Cantidad_Embalaje,status';
        var query2 = 'value, id, Valor_solicitud, Peso_Recogidos_Kg,Peso_Aproximado_Kg,';
        var query5 = 'Fecha_Prestar_Servicio,UM_P_Venta,UM_P_Compra,Sucursal, R9470155 from Solicitud_Servicio where R8634058=' + this.auth.getId() + ' and status';
        let query6 = 'value is not null order by id Desc WITH (NOLOCK)&sessionId=' + this.auth.getToken();
        let totQue = encodeURI(query) +
            encodeURIComponent('#') + encodeURI(query2) +
            encodeURI(query5) +
            encodeURIComponent('#') + encodeURI(query6);
        const url = `${getUrlEnvironment()}rest/api/selectQuery?startRow=0&maxRows=1000&output=json&query=` + totQue;
        return url;
    }

    private getQuery(type: string, id: any, or?) {
        let query = '';
        const userId = this.auth.getIdUserLoggedIn();
        switch (type) {
            // por tratamiento
            case 'groupers':
                query = 'select id, name from Agrupador order by name WITH (NOLOCK)';
                break;

            case 'groupersNormal':
                query = 'select id, name from Agrupador where id in(' + id + ') order by name WITH (NOLOCK)';
                break;

            case 'groupuserCompra':
                query = `select distinct(RPCompra_Agrup) from Precios_de_Compra where RPCompra_Cte=${userId} and R9084365=${id[0].id}`;
                break;

            case 'materials':
                query = 'select id, name from Material where Cdigo_SAP is not null and R8146476=' + id + ' order by name WITH (NOLOCK)';
                break;

            case 'materialesNormal':
                query = 'select id, name from Material where R8146476=' + id + ' and id in (' + or + ') order by name WITH (NOLOCK)';
                break;

            case 'packages':
                query = 'select id, name from Tipo_Embalaje order by name WITH (NOLOCK)';
                break;

            case 'treatment':
                query = 'select id, name from R9482977,Nombre_Tto from Tratamientos_Negociados where R9482973 = ' + userId + ' order by name WITH (NOLOCK)';
                break;
            case 'sucursal':
                query = 'select id,name,Principal from Sucursal1 where Cdigo_SAP is not null and Deudor is not null and R8173502=' + userId + ' order by name WITH (NOLOCK)';
                break;

            case 'groupuser':
                if (id[0].data) {
                    query = `select distinct R9955813 from Tabla_Precios where R9955813 is not null and R_Cliente_TP=${userId} and (R8698961=${id[0].id} or R8698961 is null)`;
                }else {
                    query = `select distinct R9955813 from Tabla_Precios where R9955813 is not null and R_Cliente_TP=${userId} and R8698961=${id[0].id}`;
                }
                break;

            case 'materialuser':
                if (id[0].data) {
                    query = `select distinct R_Material_TP from Tabla_Precios where R_Material_TP is not null and R_Cliente_TP=${userId} and (R8698961=${id[0].id} or R8698961 is null)`;
                }else {
                    query = `select distinct R_Material_TP from Tabla_Precios where R_Material_TP is not null and R_Cliente_TP=${userId} and R8698961=${id[0].id}`;
                }
                break;

            case 'materialusercompra':
                query = 'select distinct RPCompra_Material from Precios_de_Compra where RPCompra_Cte=' + userId;
                break;

            case 'unidad':
                query = 'select id,name from Unidades_Medidas order by name WITH (NOLOCK)';
                break;

            case 'centerGroup':
                query = 'select R9955799 from Agrupador_Material_Centro where id in('+ id +') order by R9955799  WITH (NOLOCK)';
                break;
        }
        return query;
    }

    private generics(type: 'centerGroup' | 'unidad' | 'groupers' | 'materials' | 'materialesNormal' | 'packages' | 'sucursal' | 'groupuser' | 'groupersNormal' | 'groupuserCompra' | 'materialuser' | 'materialusercompra', idnum: string, or?: string): Observable<any> {
        let base;
        const query: string = encodeURI(this.getQuery(type, idnum, or));
        base = this.http.get(`${getUrlEnvironment()}rest/api/selectQuery?startRow=0&maxRows=100000&output=json&query=` + query + `&sessionId=` + this.auth.getToken());

        this.datos = base.pipe(
            map(data => {
                let s = JSON.stringify(data);
                s = JSON.parse(s);
                const result = new Array<Generic>();
                for (let i = 0; i < s.length; i++) {
                    let as;
                    let oth = (s[i][2]) ? s[i][2] : '';
                    as = { 'id': s[i][0], 'label': s[i][1], 'data': oth };
                    result.push(as);
                }
                return result;
            })
        );
        return this.datos;
    }

    public getListBussines(): Observable<any> {
        let base;
        base = this.http.get(`${getUrlEnvironment()}rest/api/selectQuery?query=select Nombre_Linea,Descripcin_Lnea_de_Negocio from Linea_de_Negocio where Mostrar=true order by Nombre_Linea WITH (NOLOCK)&sessionId=` + this.auth.getToken() + '&output=json&maxRows=2000'); // =a858106871ad4e6888f46abe2a7305bb@8012571&output=json&maxRows=2000
        this.datos = base.pipe(
            map(data => {
                return data;
            })
        );
        return this.datos;
    }

    private createRequest(service: any, formlen, branch: string, orderId): Observable<any> {
        if (orderId == 0) {
            let base;
            var url = this.getQueryCreteRequest(service, branch);
            base = this.http.get(url);
            const request = base.pipe(
                map((data: Result) => {
                    let as;
                    for (let i = 0; i < formlen; i++) {
                        as = this.CreateService(data.id, service.itemRows[i]);
                    }
                    return data;
                })
            );
            return request;
        } else {
            this.CreateService(orderId, service.itemRows[0]);
        }
    }

    private getQueryCreteRequest(service: any, branch: string) {
        const userId = this.auth.getIdUserLoggedIn();
        const token = this.auth.getToken();
        let params = `&Recoleccin=${+service.itemRows[0].Recoleccion}&Presencial=${+service.itemRows[0].Presenciales}&Recepcin=${+service.itemRows[0].Recepcion}&Posfechar_Servicios=${service.itemRows[0].Servicio_Posfechado_fecha}&Anticipo=${+service.itemRows[0].Pago_Anticipo}`;
        var url = `${getUrlEnvironment()}rest/api/create2?output=json&useIds=true&objName=Orden_de_Servicio&sessionId=` + token + `&R8183919=` + userId + '&R9026340=' + branch + '&Aceptacin_Responsabilidad_de_residuos=true' + params;
        return url;
    }

    private CreateService(OrderId: string, service: any) {
        try {
            let url = this.getQueryCreateService(OrderId, service);
            this.http.get(url).subscribe(res => {
                if (res) {
                    return (res);
                }
            });
        } catch (err) {
            console.log(err);
        }
    }

    private getQueryCreateService(OrderId: string, service: any) {
        const userId = this.auth.getIdUserLoggedIn();
        const token = this.auth.getToken();
        let url = `${getUrlEnvironment()}rest/api/create2?output=json&useIds=true&objName=Solicitud_Servicio&sessionId=` + token + `&R8634058=` + userId;
        url = url + '&R8206105=' + OrderId + '&R8602650=' + service.grouper + '&R8206161=' + service.materials +
            '&Cantidad_en_Kg=' + service.qty + '&R8208895=' + service.pk + '&Cantidad_Embalaje=' + service.qtyPack;
        return url;
    }

    public createQuotation(quota): Observable<any>{

        let base;
        const userId = this.auth.getIdUserLoggedIn();
        const token = this.auth.getToken();
        const url = `${getUrlEnvironment()}rest/api/create2?output=json&useIds=true&objName=Cotizacion&sessionId=` + token + `&R5278266=` + userId + '&Cliente_Instrucciones=' + quota + '&Web=True';
        base = this.http.get(encodeURI(url));
        const request = base.pipe(
            map((data: Result) => {
                return data;
            })
        );
        return request;
    }

    public listQoute(): Observable<any>{
        let base;
        const userId = this.auth.getIdUserLoggedIn();
        base = this.http.get(`${getUrlEnvironment()}rest/api/selectQuery?query=select id,Num_Cotizacion,Fecha,Valor_Cotiza,URL_CotizacionPDF from Cotizacion where R5278266=` + userId + ' order by id desc WITH (NOLOCK)&sessionId=' + this.auth.getToken() + '&output=json&maxRows=2000');
        this.datos = base.pipe(
            map(data => {
                return data;
            })
        );
        return this.datos;
    }

    encodeQueryData(data) {
        try {
            const ret = [];
            for (const d in data)
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            return ret.join('&');
        } catch (s) {
            alert('s ' + s);
        }
    }

    buildUrlParams(object) {
        try {
            const urlParams = [];
            for (const key in object) {
                if (object.hasOwnProperty(key)) {
                    urlParams.push(key + '=' + object[key]);
                }
            }
            return urlParams.join('&');
        } catch (r) {
            alert(r);
        }
    }

    public loadSecure(content){
        const tok = this.auth.getToken();
        const xhr = new XMLHttpRequest();
        const url = `${getUrlEnvironment()}rest/api/setBinaryData?output=json&sessionId=` + tok;
        const params = this.buildUrlParams(content);
        xhr.open('POST', url, true);

        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {

            }
        };
        const eqd = this.encodeQueryData(content);

        xhr.onprogress = function (e) {
            try {
                if (e.lengthComputable) {
                    const percentComplete = (e.loaded / e.total) * 100;
                }
            } catch (f) {
                alert('f ' + f);
            }
        };

        xhr.onload = function (a) {
            console.log('onload');
        };
        xhr.onerror = function () {
            console.log('error');
        };
        xhr.onabort = function () {
            console.log('abort');
        };
        xhr.ontimeout = function () {
            console.log('timeout');
        };
        xhr.onloadstart = function () {

        };
        xhr.onloadend = function () {

        };
        xhr.send(eqd);
    }

    public updatePassword(correo, pass): Observable<any> {
        const url = this.getQueryPassword(correo, pass);
        return this.http.post(encodeURI(url), {})
            .map(data => {
                return data;
            }
            ).catch((err: Response) => {
                const details = err;
                console.log(details);
                return Observable.throw(details);
            });
    }


    private getQueryPassword(correo: any, pass: any) {
        const userId = JSON.parse(sessionStorage.getItem('contactoId'));
        const token = this.auth.getToken();
        let params = `updateRecord?output=json&objName=Contactos&id=${userId.value}&Correo_Electronico=${correo}&Contrasea=${pass}&sessionId=${token}`;
        const url = `${getUrlEnvironment()}rest/api/${params}`;
        return url;
    }

    public deleteRequest(id: number): Observable<any> {
        const token = this.auth.getToken();
        const url = `${getUrlEnvironment()}rest/api/updateRecord?output=json&useIds=false&objName=Solicitud_Servicio&status=Cancelada&sessionId=`
            + token + `&id=` + id;
        return this.http.post(url, null)
            .map(data => {
                return data;
            }
            ).catch((err: Response) => {
                const details = err;
                return Observable.throw(details);
            });
    }

    public list(unidades, sucursales): Observable<any> {
        return this.listServices(unidades, sucursales);
    }

    public getUni(): Observable<any> {
        return this.generics('unidad', '');
    }

    public grouper(id: string): Observable<any> {
        return this.generics('groupers', id);
    }

    public groupersNormal(id: string): Observable<any> {
        return this.generics('groupersNormal', id);
    }

    public centerGroup(id: string): Observable<any> {
        return this.generics('centerGroup', id);
    }


    public materials(id: string, or: string): Observable<any> {
        return this.generics('materials', id, or);
    }


    public materialesNormal(id: string, or: string): Observable<any> {
        return this.generics('materialesNormal', id, or);
    }

    public package(id: string): Observable<any> {
        return this.generics('packages', id);
    }

    public sucursal(): Observable<any> {
        return this.generics('sucursal', '');
    }

    public saveReq(service: any, Formlen: number, branch: string, orderId): Observable<any> {
        return this.createRequest(service, Formlen, branch, orderId);
    }

    public groupuser(id): Observable<any> {
        return this.generics('groupuser', id);
    }

    public groupuserCompra(id): Observable<any> {
        return this.generics('groupuserCompra', id);
    }

    public materialuser(id): Observable<any> {
        return this.generics('materialuser', id);
    }

    public materialusercompra(id): Observable<any> {
        return this.generics('materialusercompra', id);
    }
}



// WEBPACK FOOTER //
// /Users/clgingeniero/Documents/Proyectos/Impel/acertar/src/app/services/services.service.ts